import React from 'react';
import { SvgIcon } from '../styled-components';
import { SvgIconProps } from '@material-ui/core/SvgIcon';

const LaundryIcon: React.FC<SvgIconProps> = ({
  viewBox = '0 0 29.305 34.056',
  ...rest
}) => (
  <SvgIcon
    {...rest}
    viewBox={viewBox}
    style={{ width: 29.305, height: 34.056 }}
  >
    <g
      xmlns="http://www.w3.org/2000/svg"
      transform="translate(-351.039 -97.305)"
    >
      <rect
        fill="none"
        stroke="#224060"
        strokeMiterlimit="10"
        strokeWidth="2px"
        width="27.305"
        height="32.056"
        rx="1.79"
        transform="translate(352.039 98.305)"
      />
      <circle
        fill="none"
        stroke="#224060"
        strokeMiterlimit="10"
        strokeWidth="2px"
        cx="8.145"
        cy="8.145"
        r="8.145"
        transform="translate(357.547 107.743)"
      />
      <circle
        fill="none"
        stroke="#224060"
        strokeMiterlimit="10"
        strokeWidth="2px"
        cx="5.614"
        cy="5.614"
        r="5.614"
        transform="translate(360.078 110.274)"
      />
      <line
        fill="none"
        stroke="#224060"
        strokeMiterlimit="10"
        strokeWidth="2px"
        x2="27.305"
        transform="translate(352.039 103.969)"
      />
      <line
        strokeLinecap="round"
        fill="none"
        stroke="#224060"
        strokeMiterlimit="10"
        strokeWidth="2px"
        x1="3.052"
        transform="translate(372.53 101.38)"
      />
    </g>
  </SvgIcon>
);

export default LaundryIcon;
